import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { uniqueId } from '../../utils/DomUtils.js';
import { addVisibilityCallback, Visibility } from '../../utils/windowEvents/ScrollEvents.js';
import { VideoPresentation } from './VideoPresentation.js';

var VideoWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(VideoWrapper, _React$Component);
  var _super = _createSuper(VideoWrapper);
  function VideoWrapper(props) {
    var _this;
    _classCallCheck(this, VideoWrapper);
    _this = _super.call(this, props);
    _this.hideControlsTimeoutMillis = 3000;
    _this.runningIntervalMillis = 30;
    _this.videoAutoplayMarkerId = uniqueId("video-autoplay-marker-id-");
    _this.handleVisibilityChange = function () {
      _this.setState({
        playbackState: "running"
      });
    };
    _this.onRunning = function () {
      var _a, _b, _c, _d, _e, _f;
      _this.setState({
        time: ((_a = _this.videoElement) === null || _a === void 0 ? void 0 : _a.currentTime) || 0,
        videoProgress: ((_b = _this.videoElement) === null || _b === void 0 ? void 0 : _b.currentTime) / ((_c = _this.videoElement) === null || _c === void 0 ? void 0 : _c.duration) * 100 || 0
      });
      if (((_d = _this.videoElement) === null || _d === void 0 ? void 0 : _d.currentTime) && ((_e = _this.videoElement) === null || _e === void 0 ? void 0 : _e.currentTime) === ((_f = _this.videoElement) === null || _f === void 0 ? void 0 : _f.duration)) {
        _this.setState({
          playbackState: "done"
        });
        clearInterval(_this.runningInterval);
      }
    };
    _this.onVideoProgressChange = function (newProgress) {
      if (_this.videoElement.duration * (newProgress / 100) !== _this.state.time) {
        _this.setState({
          videoProgress: newProgress
        });
        _this.videoElement.currentTime = _this.videoElement.duration * (newProgress / 100);
      }
    };
    _this.onFullScreen = function () {
      if (document.fullscreenElement || _this.state.fullscreenActive) {
        // TODO: check if { capture: true } is required to prevent bugs with react >= 17
        document.removeEventListener("fullscreenchange", _this.onFullScreen);
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        _this.setState({
          fullscreenActive: false
        });
      } else {
        _this.videoContainerRef.requestFullscreen();
        _this.setState({
          fullscreenActive: true
        });
        // This function and listener is used for exiting the fullscreen with the esc key.
        setTimeout(function () {
          // TODO: check if { capture: true } is required to prevent bugs with react >= 17
          document.addEventListener("fullscreenchange", _this.onFullScreen);
        }, 200);
      }
    };
    _this.state = {
      audioPanelOpen: false,
      isMute: props.autoplay,
      audioVolume: 100,
      controlsOpen: false,
      isPosterVisible: true,
      playbackState: "paused",
      videoProgress: 0,
      canPlayState: false,
      time: 0,
      fullscreenActive: false
    };
    return _this;
  }
  _createClass(VideoWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.videoElement.volume = this.state.isMute ? 0 : this.state.audioVolume / 100;
      if (this.props.autoplay) {
        setTimeout(function () {
          addVisibilityCallback(_this2.handleVisibilityChange, [_this2.videoAutoplayMarkerId], Visibility.FULLY_VISIBLE);
        }, 1500);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // TODO: check if { capture: true } is required to prevent bugs with react >= 17
      document.removeEventListener("fullscreenchange", this.onFullScreen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (this.state.canPlayState) {
        if (!this.state.time || this.state.time === 0) {
          this.setState({
            time: this.videoElement.duration
          });
        }
      }
      if (prevState.audioVolume !== this.state.audioVolume) {
        this.videoElement.volume = this.state.audioVolume / 100;
        this.setState({
          isMute: false
        });
      } else if (prevState.isMute !== this.state.isMute) {
        this.videoElement.volume = this.state.isMute ? 0 : this.state.audioVolume / 100;
      }
      if (prevState.playbackState !== this.state.playbackState) {
        if (this.state.isPosterVisible) {
          this.setState({
            isPosterVisible: false
          });
        }
        switch (this.state.playbackState) {
          case "running":
            this.videoElement.play();
            // TODO: reset this when the video is finished
            this.runningInterval = setInterval(this.onRunning, this.runningIntervalMillis);
            break;
          case "paused":
            this.videoElement.pause();
            clearInterval(this.runningInterval);
            break;
        }
      }
    }
    // TODO playback state change handlers for hardware keys
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        time = _this$state.time,
        centerAction = _this$state.centerAction,
        videoProgress = _this$state.videoProgress,
        playbackState = _this$state.playbackState,
        isMute = _this$state.isMute,
        audioVolume = _this$state.audioVolume,
        audioPanelOpen = _this$state.audioPanelOpen,
        isPosterVisible = _this$state.isPosterVisible,
        controlsOpen = _this$state.controlsOpen;
      return /*#__PURE__*/React.createElement(VideoPresentation, Object.assign({}, this.props, {
        time: time,
        centerAction: centerAction,
        videoProgress: videoProgress,
        onVideoProgressChange: function onVideoProgressChange(newProgress) {
          return _this3.onVideoProgressChange(newProgress);
        },
        onVideoCanPlay: function onVideoCanPlay(newCanPlayState) {
          return _this3.setState({
            canPlayState: newCanPlayState
          });
        },
        playbackState: playbackState,
        onPlaybackStateChange: function onPlaybackStateChange(newState) {
          return _this3.setState({
            playbackState: newState
          });
        },
        isMute: isMute,
        onIsMuteChange: function onIsMuteChange(newMute) {
          return _this3.setState({
            isMute: newMute
          });
        },
        audioVolume: audioVolume,
        onAudioVolumeChange: function onAudioVolumeChange(newVolume) {
          return _this3.setState({
            audioVolume: newVolume
          });
        },
        audioPanelOpen: audioPanelOpen,
        onAudioPanelSetOpen: function onAudioPanelSetOpen() {
          if (audioPanelOpen !== true) {
            _this3.setState({
              audioPanelOpen: true
            });
          }
          window.clearTimeout(_this3.audioPanelTimeout);
          _this3.audioPanelTimeout = window.setTimeout(function () {
            _this3.setState({
              audioPanelOpen: false
            });
          }, _this3.hideControlsTimeoutMillis);
        },
        isPosterVisible: isPosterVisible,
        controlsOpen: controlsOpen || playbackState !== "running",
        onControlsSetOpen: function onControlsSetOpen() {
          if (controlsOpen !== true) {
            _this3.setState({
              controlsOpen: true
            });
          }
          window.clearTimeout(_this3.controlsTimeout);
          _this3.controlsTimeout = window.setTimeout(function () {
            _this3.setState({
              controlsOpen: false
            });
          }, _this3.hideControlsTimeoutMillis);
        },
        videoRef: function videoRef(r) {
          _this3.videoElement = r;
        },
        videoContainerRef: function videoContainerRef(r) {
          _this3.videoContainerRef = r;
        },
        videoElement: this.videoElement,
        videoAutoplayMarkerId: this.videoAutoplayMarkerId,
        onFullScreen: this.onFullScreen,
        fullscreenActive: this.state.fullscreenActive
      }));
    }
  }]);
  return VideoWrapper;
}(React.Component);

export { VideoWrapper };
